<div class="product-lines">
  <ng-container *ngFor="let item of items; let i = index">
    <ng-container *ngIf="getControl(item) | async as control" [class.is-changed]="control.get('quantity')?.disabled">
      <div
        cx-cart-item-list-row
        role="row"
        class="cx-item-list-row simple-card"
        [item]="parseOrderEntry(item)"
        [quantityControl]="convertQty(control.get('quantity'))"
        [readonly]="readonly"
        [promotionLocation]="promotionLocation"
        [options]="options"
        [isOrder]="isOrder"
        [displayDates]="displayDates"
        [displayValues]="displayValues"
      ></div>
    </ng-container>
  </ng-container>
</div>

<ng-template #totalHeader>
  <th role="columnheader" class="cx-item-list-total">
    {{ 'cart.cartItems.total' | cxTranslate }}
  </th>
</ng-template>
